export enum PanelType {
  SuggestedProducts = 'SuggestedProducts',
  BoughtThisSeasonTestPanel = 'BoughtThisSeasonTestPanel',
  PBasketBoughtThisSeasonPanel = 'PBasketBoughtThisSeasonPanel',
}
